import { Box, Stack } from "@mui/system";

import { spacing } from "../../../../../../../../../../assets/styles/tokens";
import ClicksWithFtdCard from "./ClicksWithFtdCard";

// ─── Static demo data (replaces sortedData from API) ─────────────────────────
const staticData = [
  {
    website_name: "Bettom Sport UK",
    website_id: "2319",
    click_out: 1751,
    table: "Bing - All Devices C",
    link: "5psFLottoGo_Casino_UK_new2_Generic_UK_100_Bonus_Up_To_200_newofferMarch12_12.03.26",
  },
  {
    website_name: "Bettom Sport UK",
    website_id: "2319",
    click_out: 1751,
    table: "Bing - All Devices C",
    link: "AhukVideoslots_Casino_in_bingo_UK_Desktop_Mobile_Tablet_smart_tv_Unknown_UK_100_Up_To_50_16.04.26",
  },
];
// ─────────────────────────────────────────────────────────────────────────────

const ClicksWithFtdItem = ({
  sortedData = staticData,
}: {
  sortedData?: any[];
}) => {
  return (
    <>
      <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
        <Stack spacing={2}>
          {sortedData?.map((item: any, index: number) => (
            <ClicksWithFtdCard
              key={index}
              website_name={item.website_name}
              website_id={item.website_id}
              click_out={item.click_out}
              table={item.table}
              link={item.link}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default ClicksWithFtdItem;
